import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductResponseDTO } from '../DTOs/response-dto/products-response-dto';
import { PostContractRequestDTO } from '../../edit-contract/dto/request-dto/post-contract-request-dto';
import { ContractDetailsResponseDTO } from '../../edit-contract/dto/response-dto/contract-details-response-dto';
import { PartnerCUResponseDto } from 'src/app/modules/admin-functions/topcon-configuration/dtos/partner-cu.dto';
import { SystemConfigResponseDTO } from '../DTOs/response-dto/system-config-response-dto';

@Injectable({
    providedIn: 'root'
})
export class CustomerContractService {
    private readonly PARTNER_GET_ENDPOINT = environment.baseUrl + 'Configuration/partners';
    private readonly PARTNER_BY_ORG_ID = environment.baseUrl + 'Configuration/products/';
    private readonly SYSTEM_CONFIG = environment.baseUrl + 'Configuration/system';

    public constructor(private http: HttpClient) { }

    public getPartners(): Observable<PartnerCUResponseDto> {
        return this.http.get<PartnerCUResponseDto>(this.PARTNER_GET_ENDPOINT);
    }

    public getProductByOrgId(id: number): Observable<ProductResponseDTO> {
        return this.http.get<ProductResponseDTO>(this.PARTNER_BY_ORG_ID + id);
    }

    public postContractDetails(
        data: PostContractRequestDTO
    ): Observable<ContractDetailsResponseDTO> {
        return this.http.post<ContractDetailsResponseDTO>(environment.baseUrl + 'Contract', data);
    }

    public getSystemConfigInfo(): Observable<SystemConfigResponseDTO> {
        return this.http.get<SystemConfigResponseDTO>(this.SYSTEM_CONFIG);
    }
}
